// filepath: /Users/chadmichel/PanicBlaster/portal/Frontend/src/environments/environment.mock.ts
export const environment = {
  production: false,
  mock: true, // Indicates this is a mock environment
  // Use relative URL so MSW can intercept requests (MSW runs in browser, same origin)
  apiUrl: '/api/v1',
  baseUrl: '/',
  appName: "CashZap",
  version: '1.0.0-mock',
  // Add mock-specific configuration
  authConfig: {
    tokenExpiration: 3600, // seconds
    refreshThreshold: 300, // seconds before expiration to trigger refresh
    useMockAuth: true, // Flag to use mock authentication
  },
  caching: {
    defaultTTL: 60, // seconds
    longTTL: 300, // seconds
  },
  features: {
    analytics: false,
    notifications: true,
    darkMode: true,
  },
  logLevel: 'debug', // none, error, warn, info, debug

  // Tenant configuration
  tenantId: '',

  cognitoUserPoolId: 'your-cognito-user-pool-id',
  cognitoClientId: 'your-cognito-app-client-id',
  cognitoDomain: 'your-cognito-domain',
  cognitoRegion: 'us-east-1', // adjust to your region
  cognitoScope: ['email', 'openid', 'aws.cognito.signin.user.admin', 'phone'],
  cognitoRedirectUri: 'http://localhost:4201/authcognito',
};

// For easier debugging in development mode
import 'zone.js/plugins/zone-error';
